import axios from 'axios';
import http from 'http';
import https from 'https';
import Vue from 'vue';

axios.defaults.baseURL = '';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

class ApiService {
  setHeaders(data = false, image = false, file = false) {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };

    if (data) {
      delete headersConfig['Content-Type'];
    }

    if (image) {
      headersConfig['Accept'] = 'image/png';
    }

    if (file) {
      headersConfig['Content-Type'] = 'application/pdf';
      headersConfig['Accept'] = 'application/pdf';
    }

    return headersConfig;
  }

  get(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_url}${url}`, { headers: this.setHeaders(), params: params })
        .then((response) => {
          resolve(response.data || response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  post(url, form, params = new URLSearchParams(), isFormData = false) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$config.api_url}${url}`, form, { headers: this.setHeaders(isFormData), params: params })
        .then((response) => {
          resolve(response.data || response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  postKeepAlive(url, form, params = new URLSearchParams(), isFormData = false) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$config.api_url}${url}`, form, { 
        headers: this.setHeaders(isFormData), 
        params: params, 
        httpAgent: new http.Agent({keepAlive: true}),
        httpsAgent: new https.Agent({keepAlive: true})})
        .then((response) => {
          resolve(response.data || response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  delete(url, params) {
    return new Promise((resolve, reject) => {
      axios.delete(`${Vue.prototype.$config.api_url}${url}`, { headers: this.setHeaders(), params: params })
        .then((response) => {
          resolve(response.data || response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  put(url, form, params, isFormData = false) {
    return new Promise((resolve, reject) => {
      axios.put(`${Vue.prototype.$config.api_url}${url}`, form, { headers: this.setHeaders(isFormData), params: params })
        .then((response) => {
          resolve(response.data || response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getWithoutApiUrl(url, params) {
    return new Promise((resolve, reject) => {
      axios.delete(url, { headers: null, params: params })
        .then((response) => {
          resolve(response.data || response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  downloadFile(url, params) {
    if (params.get('download')) {
      return new Promise((resolve, reject) => {
        axios.get(url, { headers: { 'responseType': 'blob' }, params: params, responseType: 'arraybuffer' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        axios.get(url, { headers: this.setHeaders(), params: params })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }

  downloadPublicFile(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_url}${url}`, { headers: { 'responseType': 'blob' }, params: params, responseType: 'arraybuffer' })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  readFile(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_url}${url}`, { headers: this.setHeaders(), params: params, onDownloadProgress: (progressEvent) => {
        // console.log('[readfile][progress][content-lenth]', progressEvent.srcElement.getResponseHeader('content-length'));
        // let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // console.log('[readfile][progress][progressEvent]', progressEvent)
        // console.log('[readfile][progress][lengthComputable]', progressEvent.lengthComputable)
        // console.log('[readfile][progress][percentCompleted]', percentCompleted);
        // console.log("[readfile] Percent Complete", progressEvent.srcElement._response.length)
        // const progress = progressEvent.loaded / progressEvent.event.target.getResponseHeader('x-file-size');
        // const percent = Math.round(progress * 100);
        // console.log("[readfile] Percent Complete " + percent + "%")
      } })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  postDataUrl(url, form, params = new URLSearchParams()) {
    return new Promise((resolve, reject) => {
      axios.post(`${url}`, form, { headers: {}, params: params })
        .then(response => {
          resolve(response.data || response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  getWithBasicAuth(url, auth) {
    return new Promise((resolve, reject) => {
      axios.get(`${url}`, auth)
        .then(response => {
          resolve(response.data || response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }


  // SAFRAS CONNECT
  // getConnect(url, params) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`${Vue.prototype.$config.api_url_connect}${url}`, { headers: this.setHeaders(), params: params })
  //       .then((response) => {
  //         resolve(response.data || response);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // }
}

export default new ApiService();
